import { Checkbox, CheckboxWrapper } from '@design-system';
import { FormEvent } from 'react';

import { MultiOptionFilter } from '../../types/Filters';

type FilterCheckboxGroupOption<T> = {
  value: T;
  label: string;
};

const FilterCheckboxGroup = <T extends string>({
  filter,
  onChange,
  options,
}: {
  filter: MultiOptionFilter<T>;
  options: FilterCheckboxGroupOption<T>[];
  onChange: (e: FormEvent<HTMLInputElement>) => void;
}) => {
  return (
    <CheckboxWrapper>
      {options.map((option) => (
        <Checkbox
          key={`${option.label}-${option.value}`}
          checked={filter.values.includes(option.value)}
          id={`${option.label}-${option.value}`}
          label={option.label}
          name={`${option.label}-${option.value}`}
          onChange={(e) => {
            onChange(e);

            if (e.currentTarget.checked) {
              filter.add(option.value);
            } else {
              filter.remove(option.value);
            }
          }}
          type="checkbox"
          value={option.value}
        />
      ))}
    </CheckboxWrapper>
  );
};

export default FilterCheckboxGroup;
